import * as React from "react";
import { CASE_SPIN_DURATION_MS, getReelStopOffset, getReelWinnerIndex } from "./reel.js";
import "./reel.css";

export function CaseReel({ items, winningIndex, amount }) {
  const viewport = React.useRef(null);
  const winner = React.useRef(null);
  const targetIndex = getReelWinnerIndex(items.length, winningIndex, amount);

  React.useLayoutEffect(() => {
    const element = viewport.current;
    const target = winner.current;
    element.style.setProperty("--case-reel-stop", `${getReelStopOffset(
      element.clientWidth, target.offsetLeft, target.offsetWidth,
    )}px`);
  }, [items, targetIndex]);

  return (
    <div className="mc-live-reel" ref={viewport} style={{ "--case-spin-duration": `${CASE_SPIN_DURATION_MS}ms` }}>
      <div>
        {[...items, ...items].map((item, index) => (
          <i key={index} className={index === targetIndex ? "mc-reel-winner" : undefined}
            ref={index === targetIndex ? winner : undefined}>
            {item.rewardImage ? <img src={item.rewardImage} alt="" /> : item.icon}
          </i>
        ))}
      </div>
      <b />
    </div>
  );
}
